import { delay, call, put, all, takeEvery } from 'redux-saga/effects'

import {
  GET_CURRENT_USER_PROFILE,
  getCurrentUserProfileSuccess,
  getCurrentUserProfileFailure,
  UPDATE_CURRENT_USER_PROFILE,
  updateCurrentUserProfileSuccess,
  updateCurrentUserProfileFailure,
  GET_BANNERS,
  getBannersSuccess,
  getBannersFailure,
  GET_ASYNC_SESSION,
  getAsyncSessionSuccess,
  getAsyncSessionFailure,
  getAsyncSession,
  SUBMIT_SERVER_LOGOUT,
  submitServerLogoutSuccess,
  submitServerLogoutFailure
} from '../actions/app'

import {
  getCurrentUserService,
  updateCurrentUserService,
  bannersService,
  getAsyncSessionService,
  submitServerLogoutService
} from '../services/app'
import { showToasts } from '../../helpers/toasts'
import { TOAST_TYPE } from '../../constants/other'

function* appWatcher() {
  yield all([
    // PLOP_APPEND_PATTERN_ANCHOR_WATCHER
    takeEvery(SUBMIT_SERVER_LOGOUT, submitServerLogoutWorker),
    takeEvery(GET_CURRENT_USER_PROFILE, getCurrentUserWorker),
    takeEvery(UPDATE_CURRENT_USER_PROFILE, updateCurrentUserWorker),
    takeEvery(GET_BANNERS, bannersWorker),
    takeEvery(GET_ASYNC_SESSION, getAsyncSessionWorker)
  ])
}

// PLOP_APPEND_PATTERN_ANCHOR_WORKER
function* getCurrentUserWorker() {
  try {
    const response = yield call(getCurrentUserService)
    yield put(getCurrentUserProfileSuccess(response))
  } catch (e) {
    yield put(getCurrentUserProfileFailure(e))
  }
}

function* submitServerLogoutWorker({ data }) {
  try {
    const response = yield call(submitServerLogoutService, data)
    yield put(submitServerLogoutSuccess(response))
  } catch (error) {
    yield put(submitServerLogoutFailure(error))
  }
}

function* updateCurrentUserWorker({ userId, userData }) {
  try {
    const response = yield call(updateCurrentUserService, userId, userData)
    yield put(updateCurrentUserProfileSuccess(response))
  } catch (e) {
    yield put(updateCurrentUserProfileFailure(e))
  }
}

function* bannersWorker() {
  try {
    const bannersData = yield call(bannersService)
    yield put(getBannersSuccess(bannersData))
  } catch (e) {
    yield put(getBannersFailure(e))
  }
}

function* getAsyncSessionWorker({ sessionId, platform, params }) {
  try {
    const sessionData = yield call(getAsyncSessionService, sessionId, platform, params)

    if (sessionData.status === 'COMPLETED') {
      yield put(getAsyncSessionSuccess(sessionData))
    } else if (sessionData.status === 'FAILED') {
      const error = sessionData.result.error
      showToasts({
        type: TOAST_TYPE.error,
        message: error.error_user_msg
      })
      yield put(getAsyncSessionFailure(error, sessionData))
    } else {
      // SHOP-956 periodically check the endpoint until we get status "COMPLETED" or "FAILED"
      yield delay(3000)
      yield put(getAsyncSession(sessionId, platform, params))
    }
  } catch (e) {
    yield put(getAsyncSessionFailure(e))
  }
}

export default appWatcher
